import { Component, OnInit, Inject } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';

import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

import { IEquipment } from '@services/registrations/registrations.models';
import { RegistrationsService } from '@services/registrations';

@Component({
	selector: 'app-transfer-bike',
	templateUrl: './transfer-bike.component.html',
	styleUrls: ['./transfer-bike.component.scss']
})
export class TransferBikeComponent implements OnInit {

	formInputs = new FormGroup({
		email: new FormControl('', [Validators.required])
	});

	constructor(
		@Inject(MAT_DIALOG_DATA) public dialogData,
		private dialogRef: MatDialogRef<TransferBikeComponent>,
		public registrationsService: RegistrationsService
	) { }

	ngOnInit(): void {
		console.log(this.dialogData['bike']);
	}

	close(): void {
		this.dialogRef.close();
	}

	beginTransfer(): void {
		console.log('TransferBikeComponent - beginTransfer: ', this.dialogData['bike']);
		this.registrationsService.transferBike(this.dialogData['bike']['bikeUuid'], this.formInputs.controls.email.value).subscribe((res: IEquipment) => {
			// toast message
			this.dialogRef.close();
		});
	}
}
